export { default as CouponCardForPayment } from './coupon-card-for-payment'
